module.exports = __webpack_public_path__ + "img/contact_banner.ab1d1f4e.png";